jQuery(async function($){

    let current_page = 1;
    let team_id = null;
    let city_id = null;

    $(".vacancies__button .btn").on('click', async (e) => {
        e.preventDefault();

        current_page++;
        team_id = $('select[name="team"]').val();
        city_id = $('select[name="city"]').val();

        await searchJobs($, current_page,(data, totalItems, totalPages) => {

            if ( current_page == 1 ) {
                $('.vacancies__list').html('');
            }

            let html = '<h3 class="not-found">Desculpe, nenhuma vaga com seus critérios foi encontrada</h3>';
    
            if ( totalItems > 0 ) {
                html = '';

                for(let index in data) {
                    let item = `
                        <li class="vacancy wow fadeInUp delay-800ms">
                            <div class="vacancy__infos">
                                <a href="${data[index].link}">
                                    <span class="vacancy__infos--name">
                                        ${data[index].title.rendered}
                                    </span>
                                </a>
                                <span class="vacancy__infos--category">
                                    ${data[index].team.name}
                                </span>
                                </div>
                            <div class="vacancy__location">
                                <span class="vacancy__location--label">Local</span>
                                <span class="vacancy__location--name">
                                    ${data[index].city.name}
                                </span>
                            </div>
                            <div class="vacancy__action">
                                <a href="${data[index].guid.rendered}" class="btn__border blue">Detalhes da vaga</a>
                            </div>
                        </li>
                    `
                    html += item;
                }

            }
            
            if ( current_page == totalPages ) {
                $(".vacancies__button .btn").hide();
            }
    
            $('.vacancies__list').append(html);
        });

    });

    $(".searching-box .searching-box__select--button").on('click', async(e) => {

        e.preventDefault();

        current_page = 1;
        team_id = $('select[name="team"]').val();
        city_id = $('select[name="city"]').val();

        await searchJobs($, current_page,(data, totalItems, totalPages) => {

            let html;

            if ( current_page == 1 ) {
                $('.vacancies__list').html('');
            }
    
            if ( totalItems > 0 ) {
                html = '';

                for(let index in data) {
                    let item = `
                        <li class="vacancy wow fadeInUp delay-800ms">
                            <div class="vacancy__infos">
                                <a href="${data[index].link}">
                                    <span class="vacancy__infos--name">
                                        ${data[index].title.rendered}
                                    </span>
                                </a>
                                <span class="vacancy__infos--category">
                                    ${data[index].team.name}
                                </span>
                                </div>
                            <div class="vacancy__location">
                                <span class="vacancy__location--label">Local</span>
                                <span class="vacancy__location--name">
                                    ${data[index].city.name}
                                </span>
                            </div>
                            <div class="vacancy__action">
                                <a href="${data[index].guid.rendered}" class="btn__border blue">Detalhes da vaga</a>
                            </div>
                        </li>
                    `
                    html += item;
                }
            } else if(totalItems == 0) {
                html = '<h3 class="not-found">Desculpe, nenhuma vaga com seus critérios foi encontrada</h3>';

                $(".vacancies__button .btn").hide();
            }

            $('.vacancies__list').append(html);
           
            if ( current_page >= totalPages ) {
                $(".vacancies__button .btn").hide();
            } else {
                $(".vacancies__button .btn").show();
            }
        });
    });
    
    async function searchJobs($, page, callback) {
    
        let base_query = `${BASE_URL}/wp-json/wp/v2/jobs?`;
    
        let pageQuery = page === null ? '' : `page=${page}&`;
        let teamQuery = team_id === null ? '' : `team=${team_id}&`;
        let cityQuery = city_id === null ? '' : `city=${city_id}&`;
    
        let query = base_query + teamQuery + cityQuery + pageQuery;
    
        await $.ajax({
            url: query,
            success: (data, textStatus, jqxhr) => {
                let totalItems = jqxhr.getResponseHeader('X-WP-Total');
                let totalPages = jqxhr.getResponseHeader('X-WP-TotalPages');
                
                callback(data, totalItems, totalPages);
            }
        });
    }
});
